import { Component, OnInit, ViewChild , ElementRef } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { MatDialog } from '@angular/material/dialog';
import { PriceHistoryService } from '../../services/price-history.service';
import { Methods } from '../../shared/methods';
import { DinamicData, Cell } from '../../models/dinamic-data';
import { ManuracturerService } from '../../services/manuracturer.service';
import { Router } from '@angular/router';
import { CrudInventoryComponent } from '../inventory/crud-inventory/crud-inventory.component';
import { BuscadorComponent } from "./buscador/buscador.component";
import { ApexAxisChartSeries, ApexChart, ApexDataLabels, ApexGrid, ApexOptions, ApexPlotOptions, ApexStroke, ApexTitleSubtitle, ApexTooltip, ApexXAxis, ApexYAxis, ChartComponent } from 'ng-apexcharts';
import { UserService } from '../../services/user.service';
import ApexCharts from 'apexcharts';
import { TitleService } from '../../services/title.service';
import { ConfigService } from "../../services/config.service";

import jsPDF from 'jspdf';
import { PrincipalinventoryService } from 'src/app/services/principalinventory.service';
import { MobilesdevicesService } from "../../services/mobilesdevices.service"
import { SecurazeService } from "../../services/securaze.service";

declare var $: any;

export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  xaxis: ApexXAxis;
  stroke: ApexStroke;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  yaxis: ApexYAxis;
  tooltip: any;
  colors: string[];
  title: ApexTitleSubtitle;
  subtitle: ApexTitleSubtitle;
  grid: ApexGrid;
};

@Component({
  selector: 'app-price-history',
  templateUrl: './price-history.component.html',
  styleUrls: ['./price-history.component.css'],
  providers: [ UserService ]
})

export class PriceHistoryComponent implements OnInit {

  public mtds: Methods = new Methods();

  public mfgrList: Array<any> = [];
  public loadingMFGR = false;

  public options: Array<any> = [];
  public loading = false;

  public campoBusqueda = '';
  public paginaActual = 1;
  public itemsPorPagina = '10';
  public totalItems = 0;
  public totalPaginas = 1;
  public tablaDinamicaSet: boolean = false;
  public filterMfgrId = '';
  public filteritem = '';
  public filterMfgr = '';
  public filtertype = 'All';
  public filterDescription = '';
  public filtros = [];
  public chartData = {
    po_dates: [],
    unit_costs: []
  };
  public chartDataIn = {
    so_dates: [],
    unit_costs: []
  }
  public filterrigh = "";
  public sortStates = ""; 
  public maxValueIn: number
  public maxValuechar:number
  @ViewChild('chart1') chartElementRef: ElementRef;
  @ViewChild('chart2') chartElementRef2: ElementRef;
 /*  @ViewChild("chart") chart: ChartComponent; */
  public chartOptions: Partial<ChartOptions>;
  public chartOptions2: Partial<ChartOptions>;
//
public urlUpload;
public identity;
public companyLinkedData;
public token
public userlogged;
selectedPeriod: string | null = null; 
public sinceDate: any = null;
public toDate;
showCustomInputs: boolean = false;
public now:  Date;
searching: boolean = false;
/*  */
public showDetails = false;
public showSpecs = false;
public showSpecsWorkflow = false;
public showBothSpecs = false;
public workflow: string[][];
public internalComments;
public systemComments;
public disabled = true;
public apikey;
public batteries: string[][];
public components: string[][];
public cpus: string[][];
public hdds: string[][];
public memories: string[][];
public networks: string[][];
public system: string[][];
public testing: string[][];
public video: string[][];
public poline;
public batchline;
public mdm;
public computrace;
selectedTabIndex: number = 1; // Inicializa a 0 para que la primera pestaña esté activa por defecto
public idSerialMapping;
/* bitraser */
public raserhardware = null;
public raserbatery = null;
public raserdisk = null;
public raservideo = null;
public raserhardwaretest = null;
public rasermemory = null;
public rasernetwork = null;
public raserprocessor = null;
public bitrasershow = false
/* phonecheck */
public phonecheckinfo = null;
public phonecheckpart = null;
public phonecheckshow = false;
/*MOSTRAR WORKFLOW ÁRBOL*/
public inventoryLogId;
public showSpecsTree = false;
public itemsTree: Array<any> = [];
public specsTree: Array<any> = [];
public logs: Array<any> = [];
//
  public data: DinamicData = new DinamicData(
    [
      'id',
      'item',
      'Purchase Date',
      'Vendor',
      'PO Condition',
      'Qty.',
      'Revenue Share',
/*       'Unit Cost', */
      'Purchase Cost',
      'PO#',
      'PO Rep',
      'Status',
      'Sale Date',
      'Client',
      'SO Condition',
      'Sale Price',
      'SO Rep',
      'SO#',
      'Profit',
      'Actions'
    ]
  );

  constructor(
    public dialog: MatDialog,
    private _router: Router,
    private titleService: Title,
    private _mfgrService: ManuracturerService,
    private _service: PriceHistoryService,
    private _serviceprincipal: PrincipalinventoryService,
    private _userService: UserService,
    private _config: ConfigService,
    private _securazeService: SecurazeService,
    private mobilesdevicesService: MobilesdevicesService,
    private titleServices: TitleService) {
      this.titleService.setTitle( 'Price History' );
      //
      this.chartOptions = {
        series: [],
        chart: {
          height: 550,
          type: 'area'
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'smooth'
        },
        xaxis: {
          type: 'datetime',
          categories: [],
         /*  min: new Date('2023-03-01').getTime(), // Mínimo del eje X */  
          labels: {
            format: 'yyyy-MM-dd'
          }
        },
        yaxis: {
          min: 0,
          labels: {
            formatter: (value) => {
              return `$${value}`;
            }
          }
        },
        tooltip: {
          x: {
            format: 'yyyy-MM-dd'
          }
        },
        title: {
          text: 'Purchase Price History',
          align: 'center'
        }
      };
      this.chartOptions2 = {
        series: [],
        chart: {
          height: 550,
          type: 'area'
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'smooth'
        },
        xaxis: {
          type: 'datetime',
          categories: [],
         /*  min: new Date('2023-03-01').getTime(), // Mínimo del eje X */  
          labels: {
            format: 'yyyy-MM-dd'
          }
        },
        yaxis: {
          showForNullSeries: false,
          min: 0,/*  
          max: 300000, */
          labels: {
            formatter: (value) => {
              return `$${value}`;
            }
          }
        },
        tooltip: {
          x: {
            format: 'yyyy-MM-dd'
          }
        },
        title: {
          text: 'Sales Price History',
          align: 'center'
        }
      };
      //
      this.now = new Date();
      this.identity = JSON.parse(localStorage.getItem("identity"));
      this.sinceDate = this.getFecha(this.now)
      this.toDate = this.getFecha(this.now);
      this.token = this._userService.getToken();
      this.apikey = this.identity.apiCompany;
      this._userService.getUser(this.token, this.identity.sub).subscribe(
        response => {
          if (response.code === 400 && response.msg === 'Authorization not valid') {
            this.mtds.notifyError('Your session has expired');
            localStorage.clear();
            this._router.navigate(['/pages/lock']);
          } else if(response.status == 'success') {
              this.userlogged = response.data;
              this.companyLinkedData = this.userlogged.companyLinked;

          }
        },
        error => {
          console.log(<any>error);
        }
      );
     }

  ngOnInit() {

    this.options = this.mtds.colopt(
      this.data.headers, [ false ]
    );
    // this.getData();
    // this.getMfgrList();
    this.titleServices.setTitle('Price History');
    this._config.getConfig("pricehistoryoptitable").subscribe(
      (r) => {
        console.log("tabladinamica => ", r);
        if (r.data) {
          this.tablaDinamicaSet = true;
          this.options = JSON.parse(r.data.data);
          this.itemsPorPagina = r.data.pageLimit;
        } else {
          this.tablaDinamicaSet = false;
          this.options = this.mtds.colopt(this.data.headers, []);
        }
        this.getData();
      },
      (error) => {
        this.mtds.notifyError(error.statusText, error.status);
        this.loading = false;
      }
    );
    this.FiltrosStart();
  }

  FiltrosStart(){
    this.filtros = [
      null,
          { key: 'item', title: 'Item', value: '', type: 'contains', key_type: 'item_type', type_options: [
            { value: 'nofilter', name: 'No Filter' }, { value: 'contains', name: 'Contains' }, { value: 'startswith', name: 'Starts With' }, { value: 'endswith', name: 'Ends With' }, { value: 'equalto', name: 'Equal To' }
          ] },
          { key: 'purchase_date', title: 'Purchase Date', value: '', type: 'contains', key_type: 'purchase_date_type', type_options: [
            { value: 'nofilter', name: 'No Filter' }, { value: 'contains', name: 'Contains' }, { value: 'startswith', name: 'Starts With' }, { value: 'endswith', name: 'Ends With' }, { value: 'equalto', name: 'Equal To' }
          ] },
          { key: 'vendor', title: 'Vendor', value: '', type: 'contains', key_type: 'vendor_type', type_options: [
            { value: 'nofilter', name: 'No Filter' }, { value: 'contains', name: 'Contains' }, { value: 'startswith', name: 'Starts With' }, { value: 'endswith', name: 'Ends With' }, { value: 'equalto', name: 'Equal To' }
          ] },
          { key: 'po_condition', title: 'Condition', value: '', type: 'equalto', key_type: 'po_condition_type', type_options: [
            { value: 'equalto', name: 'Equal To' }
          ] },
          { key: 'quantity', title: 'QTY', value: '', type: 'equalto', key_type: 'quantity_type', type_options: [
            { value: 'nofilter', name: 'No Filter' }, { value: 'equalto', name: 'Equal To' }, { value: 'notequalto', name: 'Not Equal To' }, { value: 'greaterthan', name: 'Greater Than' }, { value: 'lessthan', name: 'Less Than' }
          ] },
          { key: 'supmargin', title: 'Revenue Share', value: '', type: 'equalto', key_type: 'supmargin_type', type_options: [
            { value: 'nofilter', name: 'No Filter' }, { value: 'equalto', name: 'Equal To' }, { value: 'notequalto', name: 'Not Equal To' }, { value: 'greaterthan', name: 'Greater Than' }, { value: 'lessthan', name: 'Less Than' }
          ] },
          /* { key: 'unitcost', title: 'Unit Cost', value: '', type: 'equalto', key_type: 'unitcost_type', type_options: [
            { value: 'nofilter', name: 'No Filter' }, { value: 'equalto', name: 'Equal To' }, { value: 'notequalto', name: 'Not Equal To' }, { value: 'greaterthan', name: 'Greater Than' }, { value: 'lessthan', name: 'Less Than' }
          ] }, */
          { key: 'purchasecost', title: 'Purchase Cost', value: '', type: 'equalto', key_type: 'purchasecost_type', type_options: [
            { value: 'nofilter', name: 'No Filter' }, { value: 'equalto', name: 'Equal To' }, { value: 'notequalto', name: 'Not Equal To' }, { value: 'greaterthan', name: 'Greater Than' }, { value: 'lessthan', name: 'Less Than' }
          ] },
          { key: 'po', title: 'PO', value: '', type: 'startswith', key_type: 'po_type', type_options: [
            { value: 'startswith', name: 'Starts With' }
          ] },
          { key: 'po_rep', title: 'PO Rep', value: '', type: 'equalto', key_type: 'po_rep_type', type_options: [
            { value: 'nofilter', name: 'No Filter' }, { value: 'contains', name: 'Contains' }, { value: 'startswith', name: 'Starts With' }, { value: 'endswith', name: 'Ends With' }, { value: 'equalto', name: 'Equal To' }
          ] },
          { key: 'status', title: 'Status', value: '', type: 'contains', key_type: 'status_type', type_options: [
            { value: 'nofilter', name: 'No Filter' }, { value: 'contains', name: 'Contains' }, { value: 'startswith', name: 'Starts With' }, { value: 'endswith', name: 'Ends With' }, { value: 'equalto', name: 'Equal To' }
          ] },
          { key: 'so_date', title: 'Sale Date', value: '', type: 'contains', key_type: 'so_date_type', type_options: [
            { value: 'nofilter', name: 'No Filter' }, { value: 'contains', name: 'Contains' }, { value: 'startswith', name: 'Starts With' }, { value: 'endswith', name: 'Ends With' }, { value: 'equalto', name: 'Equal To' }
          ] },
          { key: 'client', title: 'Client', value: '', type: 'contains', key_type: 'client_type', type_options: [
            { value: 'nofilter', name: 'No Filter' }, { value: 'contains', name: 'Contains' }, { value: 'startswith', name: 'Starts With' }, { value: 'endswith', name: 'Ends With' }, { value: 'equalto', name: 'Equal To' }
          ] },
          { key: 'so_condition', title: 'So Condition', value: '', type: 'equalto', key_type: 'so_condition_type', type_options: [
            { value: 'nofilter', name: 'No Filter' }, { value: 'contains', name: 'Contains' }, { value: 'startswith', name: 'Starts With' }, { value: 'endswith', name: 'Ends With' }, { value: 'equalto', name: 'Equal To' }
          ] },
          { key: 'saleprice', title: 'Sale Price', value: '', type: 'equalto', key_type: 'saleprice_type', type_options: [
            { value: 'nofilter', name: 'No Filter' }, { value: 'equalto', name: 'Equal To' }, { value: 'notequalto', name: 'Not Equal To' }, { value: 'greaterthan', name: 'Greater Than' }, { value: 'lessthan', name: 'Less Than' }
          ] },
          { key: 'so_rep', title: 'SO Rep', value: '', type: 'equalto', key_type: 'so_rep_type', type_options: [
            { value: 'nofilter', name: 'No Filter' }, { value: 'contains', name: 'Contains' }, { value: 'startswith', name: 'Starts With' }, { value: 'endswith', name: 'Ends With' }, { value: 'equalto', name: 'Equal To' }
          ] },
          { key: 'so', title: 'SO', value: '', type: 'startswith', key_type: 'so_type', type_options: [
            { value: 'startswith', name: 'Starts With' }
          ] },
           { key: 'profit', title: 'Profit', value: '', type: 'equalto', key_type: 'profit_type', type_options: [
            { value: 'nofilter', name: 'No Filter' }
          ] },
          null
        ];
  }
//
updateConfig(e) {
  this.options = e;
  console.log(this.options);
  this._config.setConfig("pricehistoryoptitable", this.options).subscribe((r) => {
    console.log(r);
  });
}

//
getFecha(fecha: Date, firstday = false) {
  let dia = fecha.getDate();
  let day = dia < 10 ? '0' + dia : dia;
  let mes = fecha.getMonth() + 1;
  let month = mes < 10 ? '0' + mes : mes;
  let anio = fecha.getFullYear();
  return anio + '-' + month + '-' + (firstday ? '01' : day);
}
generateReportGeneral() {
  this.searching = true; 
  this.getdatareport().then(() => {
    this.updateChartOptions();
    let MaxIn: number = Math.round(this.maxValueIn+1000);
    let Maxchar: number = Math.round(this.maxValuechar+500);
    this.chartOptions = {
      series: [],
      chart: {
        height: 550,
        type: 'area'
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        curve: 'smooth'
      },
      xaxis: {
        type: 'datetime',
        categories: [],
       /*  min: new Date('2023-03-01').getTime(), // Mínimo del eje X */  
        labels: {
          format: 'MM-dd-yyyy'
        }
      },
      yaxis: {
        min: 0,
        max: Maxchar,
        labels: {
          formatter: (value) => {
            return `$${value}`;
          }
        }
      },
      tooltip: {
        x: {
          format: 'MM-dd-yyyy'
        }
      },
      title: {
        text: 'Purchase Price History',
        align: 'center'
      }
    };
    this.chartOptions2 = {
      series: [],
      chart: {
        height: 550,
        type: 'area'
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        curve: 'smooth'
      },
      xaxis: {
        type: 'datetime',
        categories: [],
       /*  min: new Date('2023-03-01').getTime(), // Mínimo del eje X */  
        labels: {
          format: 'MM-dd-yyyy'
        }
      },
      yaxis: {
        showForNullSeries: false,
        min: 0,  
        max: MaxIn,
        labels: {
          formatter: (value) => {
            return `$${value}`;
          }
        }
      },
      tooltip: {
        x: {
          format: 'MM-dd-yyyy'
        }
      },
      title: {
        text: 'Sales Price History',
        align: 'center'
      }
    };
    

    const seriesData1 = this.getSeriesData();
    this.chartOptions.series = seriesData1;


    const seriesData2 = this.getSeriesDataNumerical();
    this.chartOptions2.series = seriesData2;

    
    const chartElement1 = this.chartElementRef.nativeElement;
    const chart1 = new ApexCharts(chartElement1, this.chartOptions);
    
    const chartElement2 = this.chartElementRef2.nativeElement;
    const chart2 = new ApexCharts(chartElement2, this.chartOptions2);
    console.log(MaxIn)
    this.chartOptions2.yaxis.max = 300000
/*     this.chartOptions.yaxis.max = this.maxValuechar
   */
/*     console.log("entre")
    console.log(this.chartOptions2.yaxis.max)
    console.log("us")
    console.log(this.chartOptions.yaxis.max) */
    chart1.render().then(() => {
      window.setTimeout(() => {
        chart1.dataURI({
          scale: 2, // Duplicar la escala de la imagen
          width: 400 // Ancho personalizado de la imagen
        }).then((data1) => {
          if ('imgURI' in data1) {
            chart2.render().then(() => {
              window.setTimeout(() => {
                chart2.dataURI({
                  scale: 2, // Duplicar la escala de la imagen
                  width: 400 // Ancho personalizado de la imagen
                }).then((data2) => {
                  if ('imgURI' in data2) {
                    const pdf = new jsPDF();
                    const imgWidth = 175;
                    const imgHeight = 70;
                    const gap = 20; // Espacio entre las dos gráfica
                    pdf.addImage(data1.imgURI, 'PNG', 10, 10, imgWidth, imgHeight);
                    pdf.addImage(data2.imgURI, 'PNG', 10, 10 + imgHeight + gap, imgWidth, imgHeight); 

                    const blob = pdf.output('blob');
                    const url = URL.createObjectURL(blob);
                    window.open(url, '_blank');

                    URL.revokeObjectURL(url);
                  } else {
                    console.error('imgURI not found in data2');
                  }
                  this.searching = false;
                });
              }, 1000);
            });
          } else {
            console.error('imgURI not found in data1');
            this.searching = false;
          }
        });
      }, 1000);
    });
  }).catch(error => {
    console.error("Error fetching data", error);
    this.searching = false;
  });
}


//
getSeriesDataNumerical(): any[] {
  return [{
    name: 'UnitPrice',
    data: this.chartDataIn.so_dates.map((date, index) => {
      const dateObj = new Date(date);
      if (isNaN(dateObj.getTime())) {
        console.error(`Invalid date: ${date}`);
        return null;
      }
      return {
        x: dateObj.toISOString(),
        y: this.chartDataIn.unit_costs[index]
      };
    }).filter(dataPoint => dataPoint !== null)
  }];
}

getSeriesData(): any[] {
  return [{
    name: 'UnitCost',
    data: this.chartData.po_dates.map((date, index) => {
      const dateObj = new Date(date);
      if (isNaN(dateObj.getTime())) {
        console.error(`Invalid date: ${date}`);
        return null;
      }
      return {
        x: dateObj.toISOString(),
        y: this.chartData.unit_costs[index]
      };
    }).filter(dataPoint => dataPoint !== null)
  }];
}


//
onPeriodChange(value: string) {
  if (value === 'custom') {
    this.customclick();
  } else {
    this.selectPeriod(value);
  }
}
selectPeriod(period: string) {
  this.selectedPeriod = period;
  this.showCustomInputs = false; 
}
customclick(){
  this.selectedPeriod = 'Custom';
  this.showCustomInputs = true;
}
getdatareport(): Promise<void> {
  return new Promise((resolve, reject) => {
    this._service.showAll(
      1,
      0,
      '',
      this.filteritem,
      this.filterMfgr,
      this.filtertype,
      this.filtros
    ).subscribe(
      r => {
        /* this.selectedPeriod = null; */
        console.log("response pricehistory => ", r);
        if (r.code === 400 && r.msg === 'Authorization not valid') {
          this.mtds.notifyError('Your session has expired');
          localStorage.clear();
          this._router.navigate(['/pages/lock']);
          reject();
        } else if (r.status === 'success') {
          this.chartData.po_dates = [];
          this.chartData.unit_costs = [];
          this.chartDataIn.so_dates = [];
          this.chartDataIn.unit_costs = [];
          const formatDate = (date: Date): string => {
            return date.toISOString().split('T')[0]; // Formato 'yyyy-MM-dd'
          };
          let startDate: Date = null;
          let nowDateStr = formatDate(this.now);
          switch (this.selectedPeriod) {
            case 'a month':
              startDate = new Date(this.now.getFullYear(),this.now.getMonth() - 1, this.now.getDate());
              console.log("here")
              break;
            case 'three months':
              startDate = new Date(this.now.getFullYear(), this.now.getMonth() - 3, this.now.getDate());
              break;
            case 'six months':
              startDate = new Date(this.now.getFullYear(), this.now.getMonth() - 6, this.now.getDate());
              break;
            case 'a year':
              startDate = new Date(this.now.getFullYear() - 1, this.now.getMonth(), this.now.getDate());
              break;
              case 'Custom':
                nowDateStr = this.sinceDate;
                startDate = new Date(this.toDate);
                break;
            default:
              startDate = new Date(0); // Sin filtro si no se selecciona un período
              break;
          }


          const startDateStr = formatDate(startDate);
          for (const element of r.data) {
            const poDateStr = formatDate(new Date(element.po_date));
            const soDateStr = formatDate(new Date(element.so_date));
            if (element.status === 'Available' && poDateStr >= startDateStr && poDateStr <= nowDateStr) {
              this.chartData.po_dates.push(poDateStr);
              this.chartData.unit_costs.push(element.unitcost);
            }
            if (element.status === 'Invoiced'  && soDateStr >= startDateStr && soDateStr <= nowDateStr) {
              this.chartDataIn.so_dates.push(soDateStr);
              this.chartDataIn.unit_costs.push(element.unitprice);
            }
          }
         
         /*  console.log(this.chartDataIn.unit_costs)
          console.log(this.chartData.unit_costs) */
          // Configurar las gráficas con el valor máximo
          /* this.updateChartOptions(); */
          resolve();
        } else {
          reject();
        }
      },
      error => {
        console.log(error);
        reject();
      }
    );
  });
}
//
updateChartOptions() {
  this.maxValueIn=Math.max(...this.chartDataIn.unit_costs)
  this.maxValuechar=Math.max(...this.chartData.unit_costs)
  
}

//

  getMfgrList() {
    this._mfgrService.showAllLite().subscribe(
      r => {
        this.mfgrList = r.data;
        this.loadingMFGR = false;
      }
    );
  }

  openBuscador() {
    let dialogRef;
    dialogRef = this.dialog.open(BuscadorComponent, {
      width: "90%",
      height: "auto",
      data: {
        "search": this.filteritem
      },
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
    
      if(result && result.action && result.action == 'Show' && result.id){
        this.mfgrList = [];
        this.filteritem = result.id.partNumber;
       
        this.mfgrList.push(
              { id: result.id.mfgr.id, name: result.id.mfgr.name, description: result.id.mfgr.descripcion }
            );
        this.filterMfgr = result.id.mfgr.name;
        this.byItem(false);
      }
      //this.recargar.emit(true);
    });
  }

  byMfgr(e) {
    console.log(e);
    this.filterMfgrId = e.id;
    this.filterMfgr = e.id !== null ? e.name : '';
    this.filterDescription = e.id !== null ? e.description : '';
    this.getData();
  }
  previousFilterItem: string = '';
  byEnter(){
    if (this.filteritem !== this.previousFilterItem || this.filteritem === '') {
      this.previousFilterItem = this.filteritem;
    } else {
      this.byItem();
    }

  }
  byItem(cargarMfgr = true) {
    this.selectedPeriod = null;
    this.showCustomInputs = false;
    let me = this;
    console.log(this.filteritem);
    if(this.filteritem == '')
      return false;
    this.loadingMFGR = true;
    if(cargarMfgr)
    this.mfgrList = [];
    this._service.searchfilger(this.filteritem).subscribe(
      (r) => {
        console.log(r);
     
        if(r.data.length == 0){
          me.openBuscador();
        }

        for (const item of r.data) {
          let find = false;
          for (const mfgr of this.mfgrList) {
            if (item.mfgr.id === mfgr.id) {
              find = true;
              break;
            }
          }
          if(cargarMfgr)
          if (!find) {
            this.mfgrList.push(
              { id: item.mfgr.id, name: item.mfgr.name, description: item.descripcion }
            );
          }
        }

        if(cargarMfgr)
        this.mfgrList.sort(function(a, b) {
          var textA = a.name.toUpperCase();
          var textB = b.name.toUpperCase();
          return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
      });


        if (this.mfgrList.length && cargarMfgr) {
          this.filterMfgrId = this.mfgrList[0].id;
          this.filterMfgr = this.mfgrList[0].name;
          this.filterDescription = this.mfgrList[0].description;
        }
        this.loadingMFGR = false;
        this.getData();
      }
    );
  }

  action(e) {
    console.log(e);

    switch (e.action) {
      case 'Detail':
        const dialogRef = this.dialog.open(CrudInventoryComponent, {
          width: '80%',
          data: e,
        });

        dialogRef.afterClosed().subscribe( (result) => {
          if (result) {
            this.getData();
          }
        });
        break;
      case "Attribute":
        const originalIds = e.id.replace('-h', '');
          this.showDetails = true;
          this.showSpecs = false;
          this.showSpecsWorkflow = false;
          this.showSpecsTree = false;
  
          this.showBothSpecs = false;
  
          this.batteries = [];
          this.components = [];
          this.cpus = [];
          this.hdds = [];
          this.memories = [];
          this.networks = [];
          this.system = [];
          this.testing = [];
          this.video = [];
  
          this.internalComments = "";
          this.systemComments = "";
  
          this.workflow = [];
  
          this._serviceprincipal.getAttributes(originalIds, "inventory").subscribe(
            (response) => {
              console.log(response);
              if (response.status === "success") {
                if (response.data.testing) {
                  this.mdm = response.data.testing[0].mdm;
                  this.computrace = response.data.testing[0].computrace;
                }
  
                this.batteries = response.data.batteries;
                this.components = response.data.components;
                this.cpus = response.data.cpus;
                this.hdds = response.data.hdds;
                this.memories = response.data.memories;
                this.networks = response.data.networks;
                this.system = response.data.system;
                this.testing[0] = response.data.testing[0];
                this.video = response.data.video;
                this.poline = response.data.inventory.poline;
                this.batchline = response.data.batchNumber;
  
                this.internalComments = response.data.inventory.internalComments;
                this.systemComments = response.data.inventory.systemcomments;
  
                this.showSpecs = true;
  
                if (this.showSpecs && this.showSpecsTree) {
                  this.showBothSpecs = true;
                  this.showSpecs = false;
                  this.showSpecsTree = false;
                }
              } else {
                this.internalComments = response.data.internalComments;
                this.systemComments = response.data.systemcomments;
              }
            },
            (error) => {
              //this.mtds.notifyError('Inventory not found!');
              console.log("Error");
            }
          );
  
          const json = {
            apikey: this.apikey,
            data: originalIds,
          };
  
          this._serviceprincipal.getWorkflow(json).subscribe(
            (response) => {
              if (response._body) {
                let body = JSON.parse(response._body);
  
                if (body.length > 0) {
                  this.workflow = body;
                  this.showSpecsWorkflow = true;
                }
              }
            },
            (error) => {
              console.log(error);
            }
          );
  
          /*MOSTRAR SPECS DEL ÁRBOL SI ES QUE TIENE*/
          // const resultado = this.itemsTree.find((obj) => obj.id === e.id);
  
          // if (resultado.categories !== null) {
          //   this._securazeService.getSpecsTree(this.token, e.id).subscribe(
          //     (response) => {
          //       this.showSpecsTree = true;
          //       this.specsTree = response.data;
          //       console.log(this.specsTree);
          //     },
          //     (error) => {
          //       console.log(error);
          //     }
          //   );
          // }
  
          break;
      case "showLogs":
        const originalId = e.id.replace('-h', '');
        const serial = this.idSerialMapping[originalId] || null;
        e.optionalValue = serial;

        
            this.getdatabitraser(e)
            this.getdataphonecheck(e)
            this.showSpecsTree = false;
            this.selectedTabIndex = 2;
    
            this.getLogs(originalId);
            const resu = this.itemsTree.find((obj) => obj.id === originalId);

            if (resu?.categories !== null) {
              this._securazeService.getSpecsTree(this.token, originalId).subscribe(
                (response) => {
                  if(response.data.children.length === 0){
                    this.showSpecsTree = false;
                  }else{
                    this.showSpecsTree = true;
                    this.selectedTabIndex = 0;
      
                    this.specsTree = response.data;
                    console.log(this.specsTree, "specstree");
                  }
    
                },
                (error) => {
                  console.log(error);
                }
              );
            }
            this.showDetails = true;
            this.showSpecs = false;
    
           //  this.showBothSpecs = false;
    
            this.batteries = [];
            this.components = [];
            this.cpus = [];
            this.hdds = [];
            this.memories = [];
            this.networks = [];
            this.system = [];
            this.testing = [];
            this.video = [];
    
            this.internalComments = "";
            this.systemComments = "";
    
            this.workflow = [];
    
            this._serviceprincipal.getAttributes(originalId, "inventory").subscribe(
              (response) => {
                console.log(response);
                if (response.status === "success") {
                  if (response.data.testing) {
                    this.mdm = response.data.testing[0].mdm;
                    this.computrace = response.data.testing[0].computrace;
                  }
    
                  this.batteries = response.data.batteries;
                  this.components = response.data.components;
                  this.cpus = response.data.cpus;
                  this.hdds = response.data.hdds;
                  this.memories = response.data.memories;
                  this.networks = response.data.networks;
                  this.system = response.data.system;
                  this.testing[0] = response.data.testing[0];
                  this.video = response.data.video;
                  this.poline = response.data.inventory.poline;
                  this.batchline = response.data.batchNumber;
    
                  this.internalComments = response.data?.inventory.internalComments;
                  this.systemComments = response.data?.inventory.systemcomments;
    
                  this.showSpecs = true;
    
                  // if (this.showSpecs && this.showSpecsTree) {
                  //   this.showBothSpecs = true;
                  //   this.showSpecs = false;
                  //   this.showSpecsTree = false;
                  // }
                } else {
                  this.internalComments = response.data?.internalComments;
                  this.systemComments = response.data?.systemcomments;
                }
              },
              (error) => {
                //this.mtds.notifyError('Inventory not found!');
                console.log("Error");
              }
            );
    
          break;
      default:
        break;
    }
  }

  /*  */
  getdatabitraser(id){
    this.raserhardware = null
    this.raserbatery = null
    this.raserdisk = null
    this.raservideo = null
    this.raserhardwaretest = null
    this.rasermemory = null
    this.rasernetwork = null
    this.raserprocessor = null
this._securazeService.gedatabitraser(this.token, id.optionalValue).subscribe(
(response) => {
  if(response.status === "success"){
    this.bitrasershow = true
    this.raserhardware = response.data.hardwareInfo;
    this.raserbatery = response.data.batteryInfo;
    this.raserdisk = response.data.diskInfo;
    this.raservideo = response.data.graphisInfo;
    this.raserhardwaretest = response.data.hardwareTest;
    this.rasermemory = response.data.memoryInfo;
    this.rasernetwork = response.data.networkInfo;
    this.raserprocessor = response.data.proccessorInfo;
  }else{
    this.bitrasershow = false
  }

},
(error) => {
  this.phonecheckshow = false
  console.log(error);
}
);
}
  getdataphonecheck(id){
    this.phonecheckinfo = null;
    this.phonecheckpart = null;
    this.phonecheckshow = false;
    /*  let testid="K9QH4CMV71" */
    this.mobilesdevicesService.Getphonecheckdata(id.optionalValue).subscribe(
    response => {
      if(response.status === "success"){
        this.phonecheckshow = true
        this.phonecheckinfo = response.result;
        this.phonecheckpart = response.Parts.Data;
      }else{
        this.phonecheckshow = false
      }

    },
    error => {
    this.phonecheckshow = false
    console.error('Error:', error);
    }
    );

  }
public showSystemComments = false;

getLogs(id) {
  this.showSystemComments = false;

  this.inventoryLogId = id;

  this._serviceprincipal.getLogs(id, "").subscribe((r) => {
    console.log(r);
    if (r.status === "success") {
      this.systemComments = "";
      this.logs = r.data;
      this.systemComments = r.systemComments;

      $("#modalLogs").modal("show");
      if (this.logs && !this.showSpecsTree) {
        this.selectedTabIndex = 1;
      } else if (this.logs && !this.showSpecsTree && this.showSpecs) {
        this.selectedTabIndex = 2;
      }
    }
  });
}
stopPropagation(event: WheelEvent): void {
  // Prevent the scroll event from bubbling up to the parent element
  event.stopPropagation();

  //console.log(event);

  // Perform any other scrolling logic you need here
  // For example, you can manually adjust the child's scrollTop property.
  //this.childScrollElement.nativeElement.scrollTop += event.deltaY;
}
  /*  */
  handleRightClick(data: any): void {
    const columnKey = data.columnName.key;
    if(columnKey === this.filterrigh ){
      if(this.sortStates === "DESC"){
        this.sortStates = "ASC"
      }else{
        this.sortStates = "DESC"
      }
    } else{
      this.sortStates = "ASC"
    }
    this.filterrigh = columnKey;
/*     console.log("t1")
    console.log(this.filterrigh)
    console.log(this.sortStates)
    console.log("t1") */
    this.getData();
  }

  getData(e = null, newfilter = true) {
    if(!this.filterMfgr) return false;
    this.loading = true;

    this._service.showAllOpti(
        e !== null ? e.page : 1,
        e !== null ? e.perPage : 10,
        e !== null ? (this.campoBusqueda = e.search) : (this.campoBusqueda = ''),
        this.filteritem,
        this.filterMfgr,
        this.filtertype,
        this.filtros, this.filterrigh,this.sortStates
    ).subscribe(
      r => {
        /* this.selectedPeriod = null; */
        console.log("response pricehistory => ",r);     
        if (r.code === 400 && r.msg === 'Authorization not valid') {
          this.mtds.notifyError('Your session has expired');
          localStorage.clear();
          this._router.navigate(['/pages/lock']);
        } else if (r.status === 'success') {

          this.paginaActual = Number(r.page_actual);
          this.itemsPorPagina = String(r.items_per_page);
          this.totalItems = Number(r.total_items_count);
          this.totalPaginas = Number(r.total_pages);

          const actionButtons = [
            { icon: 'remove_red_eye', action: 'Detail', color: 'info' },
            // { icon: 'print', action: 'Print', color: 'primary' },
            // { icon: 'delete_outline', action: 'Remove', color: 'danger' }
          ];

if (newfilter){ 
           this.filtros = [
            null,
                { key: 'item', title: 'Item', value: '', type: 'contains', key_type: 'item_type', type_options: [
                  { value: 'nofilter', name: 'No Filter' }, { value: 'contains', name: 'Contains' }, { value: 'startswith', name: 'Starts With' }, { value: 'endswith', name: 'Ends With' }, { value: 'equalto', name: 'Equal To' }
                ] },
                { key: 'purchase_date', title: 'Purchase Date', value: '', type: 'contains', key_type: 'purchase_date_type', type_options: [
                  { value: 'nofilter', name: 'No Filter' }, { value: 'contains', name: 'Contains' }, { value: 'startswith', name: 'Starts With' }, { value: 'endswith', name: 'Ends With' }, { value: 'equalto', name: 'Equal To' }
                ] },
                { key: 'vendor', title: 'Vendor', value: '', type: 'contains', key_type: 'vendor_type', type_options: [
                  { value: 'nofilter', name: 'No Filter' }, { value: 'contains', name: 'Contains' }, { value: 'startswith', name: 'Starts With' }, { value: 'endswith', name: 'Ends With' }, { value: 'equalto', name: 'Equal To' }
                ] },
                { key: 'po_condition', title: 'Condition', value: '', type: 'equalto', key_type: 'po_condition_type', type_options: [
                  { value: 'equalto', name: 'Equal To' }
                ] },
                { key: 'quantity', title: 'QTY', value: '', type: 'equalto', key_type: 'quantity_type', type_options: [
                  { value: 'nofilter', name: 'No Filter' }, { value: 'equalto', name: 'Equal To' }, { value: 'notequalto', name: 'Not Equal To' }, { value: 'greaterthan', name: 'Greater Than' }, { value: 'lessthan', name: 'Less Than' }
                ] },
                { key: 'supmargin', title: 'Revenue Share', value: '', type: 'equalto', key_type: 'supmargin_type', type_options: [
                  { value: 'nofilter', name: 'No Filter' }, { value: 'equalto', name: 'Equal To' }, { value: 'notequalto', name: 'Not Equal To' }, { value: 'greaterthan', name: 'Greater Than' }, { value: 'lessthan', name: 'Less Than' }
                ] },
                /* { key: 'unitcost', title: 'Unit Cost', value: '', type: 'equalto', key_type: 'unitcost_type', type_options: [
                  { value: 'nofilter', name: 'No Filter' }, { value: 'equalto', name: 'Equal To' }, { value: 'notequalto', name: 'Not Equal To' }, { value: 'greaterthan', name: 'Greater Than' }, { value: 'lessthan', name: 'Less Than' }
                ] }, */
                { key: 'purchasecost', title: 'Purchase Cost', value: '', type: 'equalto', key_type: 'purchasecost_type', type_options: [
                  { value: 'nofilter', name: 'No Filter' }, { value: 'equalto', name: 'Equal To' }, { value: 'notequalto', name: 'Not Equal To' }, { value: 'greaterthan', name: 'Greater Than' }, { value: 'lessthan', name: 'Less Than' }
                ] },
                { key: 'po', title: 'PO', value: '', type: 'startswith', key_type: 'po_type', type_options: [
                  { value: 'startswith', name: 'Starts With' }
                ] },
                { key: 'po_rep', title: 'PO Rep', value: '', type: 'equalto', key_type: 'po_rep_type', type_options: [
                  { value: 'nofilter', name: 'No Filter' }, { value: 'contains', name: 'Contains' }, { value: 'startswith', name: 'Starts With' }, { value: 'endswith', name: 'Ends With' }, { value: 'equalto', name: 'Equal To' }
                ] },
                { key: 'status', title: 'Status', value: '', type: 'contains', key_type: 'status_type', type_options: [
                  { value: 'nofilter', name: 'No Filter' }, { value: 'contains', name: 'Contains' }, { value: 'startswith', name: 'Starts With' }, { value: 'endswith', name: 'Ends With' }, { value: 'equalto', name: 'Equal To' }
                ] },
                { key: 'so_date', title: 'Sale Date', value: '', type: 'contains', key_type: 'so_date_type', type_options: [
                  { value: 'nofilter', name: 'No Filter' }, { value: 'contains', name: 'Contains' }, { value: 'startswith', name: 'Starts With' }, { value: 'endswith', name: 'Ends With' }, { value: 'equalto', name: 'Equal To' }
                ] },
                { key: 'client', title: 'Client', value: '', type: 'contains', key_type: 'client_type', type_options: [
                  { value: 'nofilter', name: 'No Filter' }, { value: 'contains', name: 'Contains' }, { value: 'startswith', name: 'Starts With' }, { value: 'endswith', name: 'Ends With' }, { value: 'equalto', name: 'Equal To' }
                ] },
                { key: 'so_condition', title: 'So Condition', value: '', type: 'equalto', key_type: 'so_condition_type', type_options: [
                  { value: 'nofilter', name: 'No Filter' }, { value: 'contains', name: 'Contains' }, { value: 'startswith', name: 'Starts With' }, { value: 'endswith', name: 'Ends With' }, { value: 'equalto', name: 'Equal To' }
                ] },
                { key: 'saleprice', title: 'Sale Price', value: '', type: 'equalto', key_type: 'saleprice_type', type_options: [
                  { value: 'nofilter', name: 'No Filter' }, { value: 'equalto', name: 'Equal To' }, { value: 'notequalto', name: 'Not Equal To' }, { value: 'greaterthan', name: 'Greater Than' }, { value: 'lessthan', name: 'Less Than' }
                ] },
                { key: 'so_rep', title: 'SO Rep', value: '', type: 'equalto', key_type: 'so_rep_type', type_options: [
                  { value: 'nofilter', name: 'No Filter' }, { value: 'contains', name: 'Contains' }, { value: 'startswith', name: 'Starts With' }, { value: 'endswith', name: 'Ends With' }, { value: 'equalto', name: 'Equal To' }
                ] },
                { key: 'so', title: 'SO', value: '', type: 'startswith', key_type: 'so_type', type_options: [
                  { value: 'startswith', name: 'Starts With' }
                ] },
                 { key: 'profit', title: 'Profit', value: '', type: 'equalto', key_type: 'profit_type', type_options: [
                  { value: 'nofilter', name: 'No Filter' }
                ] },
                null
              ];
}
          this.data.rows = [];
          this.idSerialMapping = {};
          for (const element of r.data) {
            this.idSerialMapping[element.id] = element.serialnumber;
  
  
            if (element.is_history == 1) {
              this.idSerialMapping[element.id + '-h'] = element.serialnumber;
            }

            let is_history = false;
            let element_id = element.id;
            
            if(element.is_history == 1){
              element_id = element_id + '-h';
            }


           // console.log("element.unitprice => ", element.unitprice);
            //console.log("element.unitcost => ", element.unitcost);
            let profit_value = Number(element.unitprice) - Number(element.unitcost);
            //console.log("profit_value => ", profit_value);
            //console.log("element.po_suppliermargin => ", element.po_suppliermargin);
            let valor_porcentaje = Number(element.po_suppliermargin) / 100;
            let porcentaje_share = Number(profit_value) * Number(valor_porcentaje);
            let ganancia = Number(element.unitprice) - Number(porcentaje_share);

            //console.log("porcentaje_share => ", porcentaje_share);
            profit_value = Number(element.unitcost) - Number(ganancia);
           // console.log("profit_value => ", profit_value);
           if(
            (profit_value == Number.POSITIVE_INFINITY || profit_value == Number.NEGATIVE_INFINITY ) ||
             isNaN(profit_value)
             )
              profit_value = 0;
          else{
            profit_value = Number(profit_value.toFixed(2));
            profit_value = profit_value * -1;
          }
            

            this.data.rows.push (
              [
                new Cell(element_id),
                new Cell(element.item, { 
                }),
                new Cell(element.po_date ? this.gtsFecha(element.po_date) : '', {
                }),
                new Cell(element.po_vendor),
                new Cell(element.pocondition),
                new Cell(element.quantity),
                new Cell(element.po_suppliermargin + ' %'),
                /* new Cell(Number(element.unitcost).toFixed(2)), */
                new Cell(Number(element.purchasecost).toFixed(2)),
                new Cell(element.po !== null ? element.po + '-' + element.poline : '', {class: 'fw-bold', color: 'primary', }),
                new Cell(element.po_rep_name  ? `${element.po_rep_name[0]} ${element.po_rep_surname[0]}` : ''),
                new Cell(element.status, {class: 'fw-bold', color: element.status === 'Available' ? 'green' : 'orange'}),
                new Cell(element.so_date ? this.gtsFecha2(element.so_date) : ''),
                new Cell(element.so_client_company ? `${element.so_client_company}` : ''),
                new Cell(element.socondition),
                new Cell(element.unitprice),
                new Cell(element.so_rep_name !== null ? `${element.so_rep_name[0]} ${element.so_rep_surname[0]}` : ''),
                new Cell(element.so !== null ? element.so + '-' + element.soline : '', {class: 'fw-bold', color: 'success'}),
                new Cell(profit_value),
                new Cell(actionButtons, {type: 'actions'})
              ]
            );
            let item = {
              id: element.id,
              categories: element.categories,
            };

            this.itemsTree.push(item);
          }

        } else {
          this.mtds.notifyError(r.msg, r.code);
        }
        this.loading = false;
      },
      (error) => {
        this.loading = false;
        this.mtds.notifyError(error.statusText, error.status);
      }
    );
  }

  gtsFecha(fecha){

    fecha = fecha.split('-');
    return fecha[1]+'/'+fecha[2]+'/'+fecha[0];

  }

  gtsFecha2(fecha){
    fecha = fecha.split(' ');
    fecha = fecha[0].split('-');
    return fecha[1]+'/'+fecha[2]+'/'+fecha[0];

  }
}
